<template>
  <tela-component title="Formação de Carga">
    <v-stepper vertical flat v-model="step">
      <v-stepper-step step="1" :complete="step > 1">
        Selecionar veículo
        <small class="mt-1"
          >Informe o veículo que fará a entrega da carga</small
        >
      </v-stepper-step>
      <v-stepper-content step="1">
        <selecionar-veiculo-form-carga />
      </v-stepper-content>

      <v-stepper-step step="2">
        Selecionar pedidos e distribuir caixas
        <small class="mt-1"
          >Informe os pedidos que serão carregados e distribua-os nas
          caixas</small
        >
      </v-stepper-step>
      <v-stepper-content step="2">
        <selecionar-pedidos-distribuicao-cxs />
      </v-stepper-content>

      <v-stepper-step step="3">
        Finalizar formação de carga
        <small class="mt-1">Conferência e gravação da carga</small>
      </v-stepper-step>
      <v-stepper-content step="3"> </v-stepper-content>
    </v-stepper>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import SelecionarVeiculoFormCarga from "@/components/formacao-carga/SelecionarVeiculoFormCarga.vue";
import { mapState } from 'vuex';
import SelecionarPedidosDistribuicaoCxs from '@/components/formacao-carga/SelecionarPedidosDistribuicaoCxs.vue';
export default {
  components: {
    TelaComponent,
    SelecionarVeiculoFormCarga,
    SelecionarPedidosDistribuicaoCxs,
  },
  computed: mapState("formacaoCarga", ["step"])
};
</script>

<style>
.v-stepper__label {
  font-size: 1.1rem !important;
}
</style>

    